export default __webpack_public_path__ + "static/media/bg_pms.e2745b46.svg";